import { render, staticRenderFns } from "./MiniCard.vue?vue&type=template&id=d56ceb7a&scoped=true"
import script from "./MiniCard.vue?vue&type=script&setup=true&lang=js"
export * from "./MiniCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MiniCard.vue?vue&type=style&index=0&id=d56ceb7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d56ceb7a",
  null
  
)

export default component.exports